export default __webpack_public_path__ + "static/media/TicketCut.5be019f2.svg";